import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';

export interface RiskLevel {
  ucs?: number,
  minRisk?: number,
  name?: string,
  background: string,
  color: string,
  rgb?: string  // don't know why we need this but let's declare it here to avoid breaking anything
}

export type RiskDistribution = Array<RiskLevel>;

@Injectable()
export class RiskAreaService implements OnInit {

  constructor(private apiService: ApiService) {
    this.apiService.init();
  }

  ngOnInit() {}

  getAll(): Observable<any> {
    return this.apiService.client.riskAreas.GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/api/risk-area.service.ts